<template>
  <v-btn :loading="loading" small style="text-transform: none;" color="primary" @click="action()">
    {{ $t('text.service_report') }}
  </v-btn>
</template>


<script>
import http from "@/api/client";
  
export default {
  name: "DownloadServiceReportBtn",
  props: {
    job: Object,
  },
  components: {},

  data() {
    return {
      loading: false,
    };
  },

  methods: {
    async action() {
      this.loading = true;
      var fileName = `Order-${this.orderId}_ServiceReport.pdf`;
      console.log("Downloading service report", fileName);
      var file = await this.downloadReport(this.job.Id, fileName);
      this.saveBlobToFile(file.blob, file.filename);
      this.loading = false;
    },

    async downloadReport(jobId, filename) {
      const res = await http().get( `api2/Partner/Jobs/ServiceReport/Download//${jobId}`, { responseType: "blob" } );
      const fname = filename || this.filenameFromDisposition(res, "service_report.pdf");
      return { blob: res.data, filename: fname };
    },

    filenameFromDisposition(response, fallback) {
      try {
        const cd =
          response?.headers?.["content-disposition"] ||
          response?.headers?.["Content-Disposition"];
        if (!cd) return fallback;
        // RFC 5987 / basic filename
        const star = /filename\*\s*=\s*(?:UTF-8''|)([^;]+)/i.exec(cd);
        if (star && star[1]) return decodeURIComponent(star[1].replace(/^"|"$|'/g, ""));
        const basic = /filename\s*=\s*"?([^";]+)"?/i.exec(cd);
        if (basic && basic[1]) return basic[1];
      } catch (_) {
        console.error("Error parsing filename from Content-Disposition", _);
      }
      return fallback;
    },

    saveBlobToFile(blob, filename) {
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename || "download";
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    },
  },

  computed: {
    orderId() {
      return this.job ? (this.job.OrderId || 'S' + this.job.Id) : null;
    },
  },

  watch: {},
};
</script>

<style lang="scss" scoped></style>
